import React, { ButtonHTMLAttributes } from "react"
import * as S from "../elements"
import { Check } from "@components/Icons"

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean
}

export const FilterToggle: React.FC<Props> = ({
  children,
  active = false,
  ...rest
}) => {
  return (
    <S.FilterContainer>
      <S.FilterCircle {...rest}>
        <S.ToggleBars>
          <span />
          <span />
          <span />
        </S.ToggleBars>
        {active && (
          <S.Amount>
            <Check />
          </S.Amount>
        )}
      </S.FilterCircle>
      <S.LabelEl>{children}</S.LabelEl>
    </S.FilterContainer>
  )
}
